<div>
  @if (contentEdit && item) {
    @if (showBackgroundPicker) {
      <div class="spacing-elements">
        <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
      </div>
      <div class="spacing-elements">
        <coin-color-picker
          [isTextColorPicker]="true"
          [(ngModel)]="item.textColor"></coin-color-picker>
      </div>
    }
    <coin-email-slider
      [label]="'cms.emails.space-top' | translate"
      [(ngModel)]="item.paddingTop"></coin-email-slider>
    <coin-email-slider
      [label]="'cms.emails.space-bottom' | translate"
      [(ngModel)]="item.paddingBottom"></coin-email-slider>
  }
  <div class="email-quote-container">
    @if (contentEdit) {
      <coin-v2-text-input
        [label]="'cms.emails.quote-text-header' | translate"
        [(ngModel)]="item.content.text" />
    }
    <p class="quote-item">
      <span class="quote quote--left">&ldquo;</span>
      {{ item.content.text }}
      <span class="quote quote--right">&rdquo;</span>
    </p>
  </div>
</div>
